<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre9" id="pgepubid00002">
      CHAPTER I.</h2>
<h3 class="sigil_not_in_toc">A DOUBLE ENIGMA.
    </h3>
<p class="calibre7">
      “I'm afraid that he won't come,” said Laura McIntyre, in a disconsolate
      voice.
    </p>
<p class="calibre7">
      “Why not?”
     </p>
<p class="calibre7">
      “Oh, look at the weather; it is something too awful.”
     </p>
<p class="calibre7">
      As she spoke a whirl of snow beat with a muffled patter against the cosy
      red-curtained window, while a long blast of wind shrieked and whistled
      through the branches of the great white-limbed elms which skirted the
      garden.
    </p>
<p class="calibre7">
      Robert McIntyre rose from the sketch upon which he had been working, and
      taking one of the lamps in his hand peered out into the darkness. The long
      skeleton limbs of the bare trees tossed and quivered dimly amid the
      whirling drift. His sister sat by the fire, her fancy-work in her lap, and
      looked up at her brothers profile which showed against the brilliant
      yellow light. It was a handsome face, young and fair and clear cut, with
      wavy brown hair combed backwards and rippling down into that outward curve
      at the ends which one associates with the artistic temperament. There was
      refinement too in his slightly puckered eyes, his dainty gold-rimmed <i class="calibre16">pince-nez</i>
      glasses, and in the black velveteen coat which caught the light so richly
      upon its shoulder. In his mouth only there was something—a suspicion
      of coarseness, a possibility of weakness—which in the eyes of some,
      and of his sister among them, marred the grace and beauty of his features.
      Yet, as he was wont himself to say, when one thinks that each poor mortal
      is heir to a legacy of every evil trait or bodily taint of so vast a line
      of ancestors, lucky indeed is the man who does not find that Nature has
      scored up some long-owing family debt upon his features.
    </p>
<p class="calibre7">
      And indeed in this case the remorseless creditor had gone so far as to
      exact a claim from the lady also, though in her case the extreme beauty of
      the upper part of the face drew the eye away from any weakness which might
      be found in the lower. She was darker than her brother—so dark that
      her heavily coiled hair seemed to be black until the light shone slantwise
      across it. The delicate, half-petulant features, the finely traced brows,
      and the thoughtful, humorous eyes were all perfect in their way, and yet
      the combination left something to be desired. There was a vague sense of a
      flaw somewhere, in feature or in expression, which resolved itself, when
      analysed, into a slight out-turning and droop of the lower lip; small
      indeed, and yet pronounced enough to turn what would have been a beautiful
      face into a merely pretty one. Very despondent and somewhat cross she
      looked as she leaned back in the armchair, the tangle of bright-coloured
      silks and of drab holland upon her lap, her hands clasped behind her head,
      with her snowy forearms and little pink elbows projecting on either side.
    </p>
<p class="calibre7">
      “I know he won't come,” she repeated.
    </p>
<p class="calibre7">
      “Nonsense, Laura! Of course he'll come. A sailor and afraid of the
      weather!”
     </p>
<p class="calibre7">
      “Ha!” She raised her finger, and a smile of triumph played over her face,
      only to die away again into a blank look of disappointment. “It is only
      papa,” she murmured.
    </p>
<p class="calibre7">
      A shuffling step was heard in the hall, and a little peaky man, with his
      slippers very much down at the heels, came shambling into the room. Mr.
      McIntyre, sen., was pale and furtive-looking, with a thin straggling red
      beard shot with grey, and a sunken downcast face. Ill-fortune and
      ill-health had both left their marks upon him. Ten years before he had
      been one of the largest and richest gunmakers in Birmingham, but a long
      run of commercial bad luck had sapped his great fortune, and had finally
      driven him into the Bankruptcy Court. The death of his wife on the very
      day of his insolvency had filled his cup of sorrow, and he had gone about
      since with a stunned, half-dazed expression upon his weak pallid face
      which spoke of a mind unhinged. So complete had been his downfall that the
      family would have been reduced to absolute poverty were it not for a small
      legacy of two-hundred a year which both the children had received from one
      of their uncles upon the mother's side who had amassed a fortune in
      Australia. By combining their incomes, and by taking a house in the quiet
      country district of Tamfield, some fourteen miles from the great Midland
      city, they were still able to live with some approach to comfort. The
      change, however, was a bitter one to all—to Robert, who had to
      forego the luxuries dear to his artistic temperament, and to think of
      turning what had been merely an overruling hobby into a means of earning a
      living; and even more to Laura, who winced before the pity of her old
      friends, and found the lanes and fields of Tamfield intolerably dull after
      the life and bustle of Edgbaston. Their discomfort was aggravated by the
      conduct of their father, whose life now was one long wail over his
      misfortunes, and who alternately sought comfort in the Prayer-book and in
      the decanter for the ills which had befallen him.
    </p>
<p class="calibre7">
      To Laura, however, Tamfield presented one attraction, which was now about
      to be taken from her. Their choice of the little country hamlet as their
      residence had been determined by the fact of their old friend, the
      Reverend John Spurling, having been nominated as the vicar. Hector
      Spurling, the elder son, two months Laura's senior, had been engaged to
      her for some years, and was, indeed, upon the point of marrying her when
      the sudden financial crash had disarranged their plans. A sub-lieutenant
      in the Navy, he was home on leave at present, and hardly an evening passed
      without his making his way from the Vicarage to Elmdene, where the
      McIntyres resided. To-day, however, a note had reached them to the effect
      that he had been suddenly ordered on duty, and that he must rejoin his
      ship at Portsmouth by the next evening. He would look in, were it but for
      half-an-hour, to bid them adieu.
    </p>
<p class="calibre7">
      “Why, where's Hector?” asked Mr. McIntyre, blinking round from side to
      side.
    </p>
<p class="calibre7">
      “He's not come, father. How could you expect him to come on such a night
      as this? Why, there must be two feet of snow in the glebe field.”
     </p>
<p class="calibre7">
      “Not come, eh?” croaked the old man, throwing himself down upon the sofa.
      “Well, well, it only wants him and his father to throw us over, and the
      thing will be complete.”
     </p>
<p class="calibre7">
      “How can you even hint at such a thing, father?” cried Laura indignantly.
      “They have been as true as steel. What would they think if they heard
      you.”
     </p>
<p class="calibre7">
      “I think, Robert,” he said, disregarding his daughter's protest, “that I
      will have a drop, just the very smallest possible drop, of brandy. A mere
      thimbleful will do; but I rather think I have caught cold during the
      snowstorm to-day.”
     </p>
<p class="calibre7">
      Robert went on sketching stolidly in his folding book, but Laura looked up
      from her work.
    </p>
<p class="calibre7">
      “I'm afraid there is nothing in the house, father,” she said.
    </p>
<p class="calibre7">
      “Laura! Laura!” He shook his head as one more in sorrow than in anger.
      “You are no longer a girl, Laura; you are a woman, the manager of a
      household, Laura. We trust in you. We look entirely towards you. And yet
      you leave your poor brother Robert without any brandy, to say nothing of
      me, your father. Good heavens, Laura! what would your mother have said?
      Think of accidents, think of sudden illness, think of apoplectic fits,
      Laura. It is a very grave res—a very grave response—a very
      great risk that you run.”
     </p>
<p class="calibre7">
      “I hardly touch the stuff,” said Robert curtly; “Laura need not provide
      any for me.”
     </p>
<p class="calibre7">
      “As a medicine it is invaluable, Robert. To be used, you understand, and
      not to be abused. That's the whole secret of it. But I'll step down to the
      Three Pigeons for half an hour.”
     </p>
<p class="calibre7">
      “My dear father,” cried the young man “you surely are not going out upon
      such a night. If you must have brandy could I not send Sarah for some?
      Please let me send Sarah; or I would go myself, or—”
     </p>
<p class="calibre7">
      Pip! came a little paper pellet from his sister's chair on to the
      sketch-book in front of him! He unrolled it and held it to the light.
    </p>
<p class="calibre7">
      “For Heaven's sake let him go!” was scrawled across it.
    </p>
<p class="calibre7">
      “Well, in any case, wrap yourself up warm,” he continued, laying bare his
      sudden change of front with a masculine clumsiness which horrified his
      sister. “Perhaps it is not so cold as it looks. You can't lose your way,
      that is one blessing. And it is not more than a hundred yards.”
     </p>
<p class="calibre7">
      With many mumbles and grumbles at his daughter's want of foresight, old
      McIntyre struggled into his great-coat and wrapped his scarf round his
      long thin throat. A sharp gust of cold wind made the lamps flicker as he
      threw open the hall-door. His two children listened to the dull fall of
      his footsteps as he slowly picked out the winding garden path.
    </p>
<p class="calibre7">
      “He gets worse—he becomes intolerable,” said Robert at last. “We
      should not have let him out; he may make a public exhibition of himself.”
     </p>
<p class="calibre7">
      “But it's Hector's last night,” pleaded Laura. “It would be dreadful if
      they met and he noticed anything. That was why I wished him to go.”
     </p>
<p class="calibre7">
      “Then you were only just in time,” remarked her brother, “for I hear the
      gate go, and—yes, you see.”
     </p>
<p class="calibre7">
      As he spoke a cheery hail came from outside, with a sharp rat-tat at the
      window. Robert stepped out and threw open the door to admit a tall young
      man, whose black frieze jacket was all mottled and glistening with snow
      crystals. Laughing loudly he shook himself like a Newfoundland dog, and
      kicked the snow from his boots before entering the little lamplit room.
    </p>
<p class="calibre7">
      Hector Spurling's profession was written in every line of his face. The
      clean-shaven lip and chin, the little fringe of side whisker, the straight
      decisive mouth, and the hard weather-tanned cheeks all spoke of the Royal
      Navy. Fifty such faces may be seen any night of the year round the
      mess-table of the Royal Naval College in Portsmouth Dockyard—faces
      which bear a closer resemblance to each other than brother does commonly
      to brother. They are all cast in a common mould, the products of a system
      which teaches early self-reliance, hardihood, and manliness—a fine
      type upon the whole; less refined and less intellectual, perhaps, than
      their brothers of the land, but full of truth and energy and heroism. In
      figure he was straight, tall, and well-knit, with keen grey eyes, and the
      sharp prompt manner of a man who has been accustomed both to command and
      to obey.
    </p>
<p class="calibre7">
      “You had my note?” he said, as he entered the room. “I have to go again,
      Laura. Isn't it a bore? Old Smithers is short-handed, and wants me back at
      once.” He sat down by the girl, and put his brown hand across her white
      one. “It won't be a very large order this time,” he continued. “It's the
      flying squadron business—Madeira, Gibraltar, Lisbon, and home. I
      shouldn't wonder if we were back in March.”
     </p>
<p class="calibre7">
      “It seems only the other day that you landed.” she answered.
    </p>
<p class="calibre7">
      “Poor little girl! But it won't be long. Mind you take good care of her,
      Robert when I am gone. And when I come again, Laura, it will be the last
      time mind! Hang the money! There are plenty who manage on less. We need
      not have a house. Why should we? You can get very nice rooms in Southsea
      at 2 pounds a week. McDougall, our paymaster, has just married, and he
      only gives thirty shillings. You would not be afraid, Laura?”
     </p>
<p class="calibre7">
      “No, indeed.”
     </p>
<p class="calibre7">
      “The dear old governor is so awfully cautious. Wait, wait, wait, that's
      always his cry. I tell him that he ought to have been in the Government
      Heavy Ordnance Department. But I'll speak to him tonight. I'll talk him
      round. See if I don't. And you must speak to your own governor. Robert
      here will back you up. And here are the ports and the dates that we are
      due at each. Mind that you have a letter waiting for me at every one.”
     </p>
<p class="calibre7">
      He took a slip of paper from the side pocket of his coat, but, instead of
      handing it to the young lady, he remained staring at it with the utmost
      astonishment upon his face.
    </p>
<p class="calibre7">
      “Well, I never!” he exclaimed. “Look here, Robert; what do you call this?”
     </p>
<p class="calibre7">
      “Hold it to the light. Why, it's a fifty-pound Bank of England note.
      Nothing remarkable about it that I can see.”
     </p>
<p class="calibre7">
      “On the contrary. It's the queerest thing that ever happened to me. I
      can't make head or tail of it.”
     </p>
<p class="calibre7">
      “Come, then, Hector,” cried Miss McIntyre with a challenge in her eyes.
      “Something very queer happened to me also to-day. I'll bet a pair of
      gloves that my adventure was more out of the common than yours, though I
      have nothing so nice to show at the end of it.”
     </p>
<p class="calibre7">
      “Come, I'll take that, and Robert here shall be the judge.”
     </p>
<p class="calibre7">
      “State your cases.” The young artist shut up his sketch-book, and rested
      his head upon his hands with a face of mock solemnity. “Ladies first! Go
      along Laura, though I think I know something of your adventure already.”
     </p>
<p class="calibre7">
      “It was this morning, Hector,” she said. “Oh, by the way, the story will
      make you wild. I had forgotten that. However, you mustn't mind, because,
      really, the poor fellow was perfectly mad.”
     </p>
<p class="calibre7">
      “What on earth was it?” asked the young officer, his eyes travelling from
      the bank-note to his <i class="calibre16">fiancee</i>.
    </p>
<p class="calibre7">
      “Oh, it was harmless enough, and yet you will confess it was very queer. I
      had gone out for a walk, but as the snow began to fall I took shelter
      under the shed which the workmen have built at the near end of the great
      new house. The men have gone, you know, and the owner is supposed to be
      coming to-morrow, but the shed is still standing. I was sitting there upon
      a packing-case when a man came down the road and stopped under the same
      shelter. He was a quiet, pale-faced man, very tall and thin, not much more
      than thirty, I should think, poorly dressed, but with the look and bearing
      of a gentleman. He asked me one or two questions about the village and the
      people, which, of course, I answered, until at last we found ourselves
      chatting away in the pleasantest and easiest fashion about all sorts of
      things. The time passed so quickly that I forgot all about the snow until
      he drew my attention to its having stopped for the moment. Then, just as I
      was turning to go, what in the world do you suppose that he did? He took a
      step towards me, looked in a sad pensive way into my face, and said: `I
      wonder whether you could care for me if I were without a penny.' Wasn't it
      strange? I was so frightened that I whisked out of the shed, and was off
      down the road before he could add another word. But really, Hector, you
      need not look so black, for when I look back at it I can quite see from
      his tone and manner that he meant no harm. He was thinking aloud, without
      the least intention of being offensive. I am convinced that the poor
      fellow was mad.”
     </p>
<p class="calibre7">
      “Hum! There was some method in his madness, it seems to me,” remarked her
      brother.
    </p>
<p class="calibre7">
      “There would have been some method in my kicking,” said the lieutenant
      savagely. “I never heard of a more outrageous thing in my life.”
     </p>
<p class="calibre7">
      “Now, I said that you would be wild!” She laid her white hand upon the
      sleeve of his rough frieze jacket. “It was nothing. I shall never see the
      poor fellow again. He was evidently a stranger to this part of the
      country. But that was my little adventure. Now let us have yours.”
     </p>
<p class="calibre7">
      The young man crackled the bank-note between his fingers and thumb, while
      he passed his other hand over his hair with the action of a man who
      strives to collect himself.
    </p>
<p class="calibre7">
      “It is some ridiculous mistake,” he said. “I must try and set it right.
      Yet I don't know how to set about it either. I was going down to the
      village from the Vicarage just after dusk when I found a fellow in a trap
      who had got himself into broken water. One wheel had sunk into the edge of
      the ditch which had been hidden by the snow, and the whole thing was high
      and dry, with a list to starboard enough to slide him out of his seat. I
      lent a hand, of course, and soon had the wheel in the road again. It was
      quite dark, and I fancy that the fellow thought that I was a bumpkin, for
      we did not exchange five words. As he drove off he shoved this into my
      hand. It is the merest chance that I did not chuck it away, for, feeling
      that it was a crumpled piece of paper, I imagined that it must be a
      tradesman's advertisement or something of the kind. However, as luck would
      have it, I put it in my pocket, and there I found it when I looked for the
      dates of our cruise. Now you know as much of the matter as I do.”
     </p>
<p class="calibre7">
      Brother and sister stared at the black and white crinkled note with
      astonishment upon their faces.
    </p>
<p class="calibre7">
      “Why, your unknown traveller must have been Monte Cristo, or Rothschild at
      the least!” said Robert. “I am bound to say, Laura, that I think you have
      lost your bet.”
     </p>
<p class="calibre7">
      “Oh, I am quite content to lose it. I never heard of such a piece of luck.
      What a perfectly delightful man this must be to know.”
     </p>
<p class="calibre7">
      “But I can't take his money,” said Hector Spurling, looking somewhat
      ruefully at the note. “A little prize-money is all very well in its way,
      but a Johnny must draw the line somewhere. Besides it must have been a
      mistake. And yet he meant to give me something big, for he could not
      mistake a note for a coin. I suppose I must advertise for the fellow.”
     </p>
<p class="calibre7">
      “It seems a pity too,” remarked Robert. “I must say that I don't quite see
      it in the same light that you do.”
     </p>
<p class="calibre7">
      “Indeed I think that you are very Quixotic, Hector,” said Laura McIntyre.
      “Why should you not accept it in the spirit in which it was meant? You did
      this stranger a service—perhaps a greater service than you know of—and
      he meant this as a little memento of the occasion. I do not see that there
      is any possible reason against your keeping it.”
     </p>
<p class="calibre7">
      “Oh, come!” said the young sailor, with an embarrassed laugh, “it is not
      quite the thing—not the sort of story one would care to tell at
      mess.”
     </p>
<p class="calibre7">
      “In any case you are off to-morrow morning,” observed Robert. “You have no
      time to make inquiries about the mysterious Croesus. You must really make
      the best of it.”
     </p>
<p class="calibre7">
      “Well, look here, Laura, you put it in your work-basket,” cried Hector
      Spurling. “You shall be my banker, and if the rightful owner turns up then
      I can refer him to you. If not, I suppose we must look on it as a kind of
      salvage-money, though I am bound to say I don't feel entirely comfortable
      about it.” He rose to his feet, and threw the note down into the brown
      basket of coloured wools which stood beside her. “Now, Laura, I must up
      anchor, for I promised the governor to be back by nine. It won't be long
      this time, dear, and it shall be the last. Good-bye, Robert! Good luck!”
     </p>
<p class="calibre7">
      “Good-bye, Hector! <i class="calibre16">Bon voyage!</i>”
     </p>
<p class="calibre7">
      The young artist remained by the table, while his sister followed her
      lover to the door. In the dim light of the hall he could see their figures
      and overhear their words.
    </p>
<p class="calibre7">
      “Next time, little girl?”
     </p>
<p class="calibre7">
      “Next time be it, Hector.”
     </p>
<p class="calibre7">
      “And nothing can part us?”
     </p>
<p class="calibre7">
      “Nothing.”
     </p>
<p class="calibre7">
      “In the whole world?”
     </p>
<p class="calibre7">
      “Nothing.”
     </p>
<p class="calibre7">
      Robert discreetly closed the door. A moment later a thud from without, and
      the quick footsteps crunching on the snow told him that their visitor had
      departed.
    </p>
<p class="calibre7">
<a id="link2HCH0002">
</a>
</p>
<div class="calibre15" id="calibre_pb_5"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?6cf53eac